<div class="container-fluid mt-4 px-3">
  <div class="container-shadow px-3">
    <div *ngIf="loading" class="m-5 p-5 text-center">
      <i class="fas fa-fw fa-spinner fa-pulse fa-5x"></i>
    </div>
    <div *ngIf="!loading">
      <h4 class="py-3">{{ autoOutgoingRule.id ? 'Editing Auto Outgoing Rule' : 'New Auto Outgoing Rule' }}</h4>
      <div class="row">
        <div class="col-md-6">
          <div style="max-width: 40rem">
            <div class="form-group">
              <app-matter-search [matterId]="autoOutgoingRule.matter_id" (matter_id)="autoOutgoingRule.matter_id = $event"></app-matter-search>
              <small class="form-text text-muted">Leave matter blank and rule will apply to all matters</small>
            </div>
            <div class="form-group">
              <app-document-type-search [documentTypeId]="autoOutgoingRule.document_type_id" (document_type_id)="autoOutgoingRule.document_type_id = $event"></app-document-type-search>
            </div>
            <div class="form-group">
              <label>Involvement Role</label>
              <select class="form-control" name="role_type_id" [(ngModel)]="autoOutgoingRule.role_type_id">
                <option *ngFor="let role_type of formOptions.role_types" [value]="role_type.value">{{ role_type.label }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Send to&nbsp;&nbsp;&nbsp;</label>
              <div (click)="autoOutgoingRule.first_involvement_only = true" class="custom-control custom-radio custom-control-inline">
                <input type="radio" name="first_involvement_only" class="custom-control-input" [checked]="autoOutgoingRule.first_involvement_only" />
                <label class="custom-control-label">First contact of that role</label>
              </div>
              <div (click)="autoOutgoingRule.first_involvement_only = false" class="custom-control custom-radio custom-control-inline">
                <input type="radio" name="first_involvement_only" class="custom-control-input" [checked]="!autoOutgoingRule.first_involvement_only" />
                <label class="custom-control-label">All contacts of that role</label>
              </div>
            </div>
            <div class="form-group">
              <label>Send via</label>
              <select class="form-control" name="way" [(ngModel)]="autoOutgoingRule.way">
                <option *ngFor="let way of formOptions.ways" [value]="way.value">{{ way.label }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Minimum Priority</label>
              <select class="form-control" name="minimum_priority" [(ngModel)]="autoOutgoingRule.minimum_priority">
                <option *ngFor="let priority of formOptions.priorities" [value]="priority.value">{{ priority.label }}</option>
              </select>
            </div>
            <div class="form-group text-center">
              <button type="button" class="btn btn-primary" (click)="save()" [disabled]="saving">
                {{ saving ? 'Saving' : 'Save' }}<span *ngIf="saving">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
              </button>
              &nbsp;&nbsp;
              <button type="button" (click)="back()" [disabled]="saving" class="btn btn-outline-secondary">Cancel</button>
            </div>
          </div>
        </div>
      </div>
      <div class="py-3"></div>
    </div>
  </div>
</div>
